// Types
export const ACTION_TYPE = {
  category: 'category',
  products: 'products',
  prices: 'prices'
}
